module.exports = __webpack_public_path__ + "static/pickdevtools-6a0a597a66b72bd53d678f664a06d624.png";